// constants for api tokens
export const db_s_type = 'S';
export const db_n_type = 'N';

export const token_fields = {
    user: db_s_type,
    description: db_s_type,
    token: db_s_type,
    email: db_s_type,
    ttl: db_n_type,
};

export const token = 'token';
export const description = 'description';
export const user = 'user';
export const email = 'email';
export const ttl = 'ttl';
export const index = 'index';
